import React from "react";

import { getEvacuationPushList } from "../../../services/emergencyServices";

import AlarmList from "../../../components/AlarmList";

import emergencyAlarmIcon from "../../../assets/img/emergency/emergency-alarm-icon.png";
import { PageableRequest } from "../../../services/talkServices";
import { useLocation } from "react-router-dom";

type Props = {};
export default function EmergencyAlarm(props: Props) {
  const location = useLocation();

  const { situationId } = location.state;

  const EmergencyPushListApi = async (params: Partial<PageableRequest>) => {
    const res = await getEvacuationPushList(params, situationId);
    return res;
  };

  return (
    <AlarmList
      icon={<img src={emergencyAlarmIcon} alt="emergency-alarm-icon" />}
      getListApi={EmergencyPushListApi}
      unUseOnClick
    />
  );
}
